import { useTranslation } from 'react-i18next';

import { PLATFORM_PERMISSIONS } from '@thinknet-gmbh/platform-common';
import { Icon, ICONS, PLATFORM_THEME_COLORS, Typography } from '@thinknet-gmbh/platform-common-ui';

import { EMPLOYEE_DEVELOPMENT_ACTIONS } from 'src/pages/settings/components/employee-development/employee-development.constants';
import { useUserCanManageDocument } from 'src/hooks/user-can-manage-document.hook';

import { MainContainer, InfoBlock } from './interview-type-card.styles';

const InterviewTypeCard = ({
  data,
  handleAction,
}: {
  data: any;
  handleAction: (action: string, record: any) => void;
}) => {
  const { t } = useTranslation('settings');

  const { canDelete, canEdit } = useUserCanManageDocument({
    createdBy: data.createdBy,
    platformPermission: PLATFORM_PERMISSIONS.companyManagement,
  });

  return (
    <MainContainer>
      <div>
        <InfoBlock>
          <Typography fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
            {`${t('employeeDevelopment.labels.interviewTypeName')}:`}
          </Typography>
          <Typography>{data.name}</Typography>
        </InfoBlock>
        <div>
          {data.fieldsHeadlines.map((headline: any, index: number) => (
            <InfoBlock key={index}>
              <Typography fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
                {`${t('employeeDevelopment.labels.headline')} ${index + 1}:`}
              </Typography>
              <Typography>{headline}</Typography>
            </InfoBlock>
          ))}
        </div>
      </div>
      <div>
        {canEdit && (
          <Icon
            icon={ICONS.editAlt}
            size={22}
            color={PLATFORM_THEME_COLORS.primary.grey}
            onClick={() => handleAction(EMPLOYEE_DEVELOPMENT_ACTIONS.edit, data)}
          />
        )}
        {canDelete && (
          <Icon
            icon={ICONS.trash}
            size={22}
            color={PLATFORM_THEME_COLORS.tone.red}
            onClick={() => handleAction(EMPLOYEE_DEVELOPMENT_ACTIONS.delete, data)}
          />
        )}
      </div>
    </MainContainer>
  );
};

export default InterviewTypeCard;
